<template>
  <div class="action" :class="{'action--mobile': MobileAction}">
    <a href="javascript:void(0);" class="action-toggle circle-hover" @click.stop="toggleAction"><i class="fas fa-ellipsis-v"></i></a>
    <ul class="action-menu" @click.stop v-if="showAction">
      <li v-for="action in ActionList" :key="action.id"><a href="javascript:void(0);" @click="actionClick(action)"><span :class="ActionMaster[action].icon"></span>{{ ActionMaster[action].text }}</a></li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src
import { EventBus } from '@/event-bus.js'

export default {
  name: 'Action',
  props: {
    ActionObject: Object,
    ActionList: Array,
    MobileAction: Boolean
  },
  data() {
    return {
      showAction: false,
      ActionMaster: {
        viewEdit: {
          icon: 'fas fa-edit',
          text: 'View / Edit'
        },
        status: {
          icon: 'fas fa-pencil-alt',
          text: 'Update Status'
        },
        call: {
          icon: 'fas fa-phone',
          text: 'Schedule Call'
        },
        meeting: {
          icon: 'fas fa-comment-alt',
          text: 'Send SMS'
        },
        sms: {
          icon: 'fas fa-calendar-alt',
          text: 'Send Email'
        },
        email: {
          icon: 'fas fa-envelope',
          text: 'Schedule Meeting'
        },
        delete: {
          icon: 'fas fa-trash-alt',
          text: 'Delete'
        },
      }
    }
  },
  computed: {
    
  },
  mounted() {
    EventBus.$on(['app-click','notifications-click','settings-click'], () => {
      this.showAction = false;
    });
    EventBus.$on(['toggle-action'], (id) => {
      if (this.ActionObject.Id != id)
        this.showAction = false;
    });
  },
  methods: {
    toggleAction: function() {
      EventBus.$emit('toggle-action',this.ActionObject.Id);
      this.showAction = this.showAction ? false : true;
    },
    actionClick: function(type) {
      EventBus.$emit(type+'-action-click',this.ActionObject);
      this.showAction = false;
    }
  }
}
</script>
